module.exports = __webpack_public_path__ + "static/flux-roadmap-b2676c6db2d294fb7107806b3e1c68cb.png";